import moment from "moment";
import { useState, useEffect, useRef } from "react";
import { useAppSelector } from "../../config/hooks";

const useCountLeaveDays=()=>{
  const holidayList = useAppSelector((state) => state.appConfig.holidayList);
  
  const leaveDaysCount =(startDate:Date, endDate:Date)=>{
    const start = moment(startDate, "YYYY-MM-DD");
    const end = moment(endDate, "YYYY-MM-DD");
    var diff = end.diff(start, 'days')+1;
    const current = start.clone();

    while (current.isSameOrBefore(end)) {
      var isHoliday = holidayList.find((list) => list.Date == moment(current).format("YYYY-MM-DD"));
        const day = current.day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        if (day < 1 || day > 5) {
            //return true; // Found a weekday
            diff -= 1;
        }
        if(isHoliday){
          diff -= 1
        }
        current.add(1, 'days');
    }
    return diff;
  }
  return{leaveDaysCount};
}

export default useCountLeaveDays;